import { useAppClockService } from '@mews/framework';
import { getRepositoryQueryKey, useRepositoryQuery } from '@mews-commander/data-access';
import { dateTimeToUtc, useCommanderSelector } from '@mews-commander/utils';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks';
import { getDateRange } from '../selectors';
import { getRestrictionCalendar } from '../utils/restrictions';

const CALENDAR_EXTENT = {
    rateGroups: true,
    rates: true,
    resourceCategories: true,
    profiles: true,
    resourceCategoryTypes: false,
};

export const RESTRICTIONS_CALENDAR_QUERY_KEY = getRepositoryQueryKey('restrictions', 'getAll');

export const useCalendarRestrictions = (serviceId: string) => {
    const appClockService = useAppClockService();
    const timeUnit = useCommanderSelector((state) => getTimeUnitByServiceId(state, { serviceId }));
    const dateRange = useCommanderSelector((state) => getDateRange(state, { serviceId, appClockService }));

    return useRepositoryQuery(
        'restrictions',
        'getAll',
        {
            serviceId,
            extent: CALENDAR_EXTENT,
            startUtc: dateTimeToUtc(dateRange.startDateTime),
            endUtc: dateTimeToUtc(dateRange.endDateTime),
        },
        {
            select: (data) => {
                const rows = getRestrictionCalendar(dateRange, data, timeUnit);
                return {
                    rows,
                    entities: data,
                };
            },
        }
    );
};
